import { PopupDatePicker } from '@amzn/stencil-react-components/popup-date-picker';

import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Select } from '@amzn/stencil-react-components/select';
import { InputWrapper } from '@amzn/stencil-react-components/input';

import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { updateConditionOperators } from '../../../actions/initializeDataActions';
import {
  updateActiveFilters,
  updateDateOperator,
  updateHireEndDate,
  updateHireStartDate,
} from '../../../actions/ruleFiltersActions';
import { ConditionOperators } from '../../../constants/conditionOperators';
import { HIRE_DATE_INFO, SegmentFilters } from '../../../constants/createSegment';
import {
  activeRuleFiltersSelector,
  initialDataSelector,
  ruleFilterDateOperatorSelector,
  ruleFilterHireEndDateSelector,
  ruleFilterHireStartSelector,
} from '../../../selectors/selectors';
import toLocal from '../../../util/segmentCreation/toLocalDate';

import { IconInformationSmall } from '@amzn/stencil-react-icons';


const IconWithTooltip = withTooltip()(IconInformationSmall);
const HireDateFilter = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const dateOperator = useSelector(ruleFilterDateOperatorSelector);
  const { conditionOperatorOptions } = useSelector(initialDataSelector);
  const hireDate = useSelector(ruleFilterHireStartSelector);
  const hireEndDate = useSelector(ruleFilterHireEndDateSelector);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.HIRE_DATE_FILTER),
  );

  useEffect(() => {
    dispatch(updateConditionOperators());
  }, []);

  const onDateOperatorChange = e => {
    dispatch(updateDateOperator(e));
  };

  const onHireDateChange = e => {
    dispatch(updateHireStartDate(e));
  };

  const onHireEndDateChange = e => {
    dispatch(updateHireEndDate(e));
  };

  return (
    <>
      <Row gridGap="S100">
        <Checkbox data-testid="rule-filter-6" checked={!isDisabled} />
        <Label display="flex" fontSize={'T300'} htmlFor="rule-filter-6" id="rule-filter-label6">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage id="app.ruleFilter.label.hireDates" defaultMessage="Hire" />
          </Text>
          <Text fontSize={'T100'} style={{ fontWeight: 'bolder' }} color="primary">
            *
          </Text>

          <Spacer width="10px" />
          <IconWithTooltip title="Country" tooltipText={HIRE_DATE_INFO} color="primary70" />
        </Label>
      </Row>
      <Spacer height={8} />
      <Row gridGap={'S200'}>
        <Col width={'30%'}>
          <InputWrapper id="dateOperator" labelText="Date Operator">
            {inputProps => (
              <Select
                data-testid="date-operator"
                disabled={isDisabled}
                options={conditionOperatorOptions}
                {...inputProps}
                value={dateOperator}
                onChange={e => {
                  onDateOperatorChange(e);
                }}
              />
            )}
          </InputWrapper>
        </Col>
        {(dateOperator === ConditionOperators.EQUALS ||
          dateOperator === ConditionOperators.GREATER_THAN ||
          dateOperator === ConditionOperators.GREATER_THAN_EQUALS ||
          dateOperator === ConditionOperators.BETWEEN) && (
          <>
            <Col width={'15%'}>
              <PopupDatePicker
                disabled={isDisabled}
                data-testid="lastHireDate"
                labelText="Hire Date"
                locale="en-US"
                value={hireDate}
                onChange={e => {
                  onHireDateChange(e);
                }}
              />
            </Col>
          </>
        )}
        {(dateOperator === ConditionOperators.BETWEEN ||
          dateOperator === ConditionOperators.LESS_THAN ||
          dateOperator === ConditionOperators.LESS_THAN_EQUALS) && (
          <>
            <Col width={'15%'}>
              <PopupDatePicker
                disabled={isDisabled}
                data-testid="lastHireEndDate"
                labelText="Hire End Date"
                locale="en-US"
                value={hireEndDate}
                onChange={e => {
                  onHireEndDateChange(e);
                }}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default HireDateFilter;
